// extracted by mini-css-extract-plugin
export default {"scope-basket-modal":"bm-scope-basket-modal","css-url":"bm-css-url","basket_modal_container":"bm-basket_modal_container"};